module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-taiguo.9bd51fbb.png";